import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
    return (
        <section id="about" className="relative min-h-screen bg-forest">
            {/* Diagonal split overlay */}
            <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 bg-forest" />
                <div
                    className="absolute inset-0 bg-[#3D2314]"
                    style={{
                        clipPath: 'polygon(0 40%, 100% 0, 100% 100%, 0 100%)',
                    }}
                />
            </div>

            <div className="relative z-10 container mx-auto px-4 py-20">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="max-w-6xl mx-auto"
                >
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-12 text-accent-green">
                        About Us
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            className="space-y-6"
                        >
                            <h3 className="text-2xl md:text-3xl font-semibold text-cream">
                                Who We Are
                            </h3>
                            <p className="text-cream text-base md:text-lg leading-relaxed">
                                PlatypusBox is a versatile technology company specializing in a broad spectrum of digital solutions.
                                Our passionate team of developers, designers, and creatives brings your vision to life across apps,
                                games, websites, and dynamic event technologies.
                            </p>
                            <p className="text-cream text-base md:text-lg leading-relaxed">
                                We�re not just coders�we're creators. From intuitive UI/UX and high-end graphic design to engaging
                                video editing and stunning anamorphic visuals, we help brands connect through compelling experiences.
                            </p>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                            className="space-y-6"
                        >
                            <h3 className="text-2xl md:text-3xl font-semibold text-cream">
                                Our Mission
                            </h3>
                            <p className="text-cream text-base md:text-lg leading-relaxed">
                                Our mission is to deliver comprehensive digital solutions that spark innovation, accelerate growth,
                                and elevate brand presence. Whether you're launching a mobile app, setting up an expo booth with
                                interactive technology, or building a modern, high-performance website�we�ve got you covered.
                            </p>
                            <p className="text-cream text-base md:text-lg leading-relaxed">
                                We are proud to offer an integrated suite of services�from software development and web design
                                to motion graphics, UI/UX design, and advanced video editing�ensuring every detail aligns with your vision.
                            </p>
                        </motion.div>
                    </div>

                    {/* Values or Key Points */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-16"
                    >
                        {[
                            {
                                title: "Innovation",
                                description: "From game mechanics to anamorphic visuals, we push digital boundaries."
                            },
                            {
                                title: "Quality",
                                description: "Detail-driven design and code, with a strong focus on user experience."
                            },
                            {
                                title: "Versatility",
                                description: "Apps, web, design, events, and media�all under one creative roof."
                            }
                        ].map((value, index) => (
                            <div
                                key={value.title}
                                className="bg-[#0A2F1D] p-6 rounded-lg border border-accent-green/20 hover:border-accent-green/50 transition-all"
                            >
                                <h4 className="text-xl font-semibold text-accent-green mb-3">
                                    {value.title}
                                </h4>
                                <p className="text-cream">
                                    {value.description}
                                </p>
                            </div>
                        ))}
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default About;
